import React from 'react';
import PatrimonyForm from './PatrimonyForm';
import Button from '../../ui/buttons/Button';

const newTempId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

const PatrimonyFormList = ({ patrimonies, onChange, canWrite = true }) => {
  // mapeia com índice original e filtra itens marcados para destroy
  const visible = patrimonies.map((p, originalIndex) => ({ ...p, _idx: originalIndex })).filter((p) => !p._destroy);

  const handleChange = (originalIndex, updated) => {
    const updatedList = [...patrimonies];
    updatedList[originalIndex] = updated;
    onChange(updatedList);
  };

  const handleAdd = () => {
    onChange([
      ...patrimonies,
      {
        tempId: newTempId(),
        name: '',
        value: '',
        description: '',
        patrimonyType: '',
        _destroy: false,
      },
    ]);
  };

  const handleRemove = (originalIndex) => {
    const updatedList = [...patrimonies];
    const item = updatedList[originalIndex];

    if (item?.id) {
      updatedList[originalIndex] = { ...item, _destroy: true };
    } else {
      updatedList.splice(originalIndex, 1);
    }
    onChange(updatedList);
  };

  return (
    <>
      <div className="space-y-4 bg-tealWhisper rounded-xl border border-tealPale p-5">
        {visible.map(({ _idx, ...patrimony }) => (
          <div
            key={patrimony.id || patrimony.tempId}
            className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6"
          >
            <PatrimonyForm
              index={_idx} // índice do array original
              patrimony={patrimony}
              onChange={handleChange}
              onRemove={handleRemove}
              canWrite={canWrite}
            />
          </div>
        ))}
      </div>

      {canWrite && (
        <div className="pt-4">
          <Button onClick={handleAdd} type="button">
            + ADICIONAR PATRIMÔNIO
          </Button>
        </div>
      )}
    </>
  );
};

export default PatrimonyFormList;
